<template>
  <div class="table-view">
  <div class="table-view__header--right p-0 col-12 d-flex justify-content-end">
        <div class="search">
          <div  class="d-flex  flex-wrap mr-5">
            <label for="search" class="ml-1 d-flex align-items-center search-by-filter" >Search&nbsp;By:
          <span class="search-by-filter__select" >
            <select
            class="search-group search-by-filter__select mx-sm-2 mx-0 px-1 my-1" style="width:257px"
            placeholder=" "
            name="search-group"
            id="search-group"
            @change="clearFilter()"
            v-model="selectOptionToFilter"
          >
          "Business Name", "Program Name", "Status"
            <option selected value="all">
              <p>All</p>
            </option>
            <option value="businessName">
              <p>Business Name</p>
            </option>
            <option value="programName">
              <p> Program Name</p>
            </option>
            <option value="fundingEntityName">
              <p>Funding Entity</p>
            </option>
            <option value="programStatus">
              <p> Status</p>
            </option>
            
            <option value="dateInvited">
              <p>Date Invited</p>
            </option>
            <option value="affiliateName">
              <p> Affiliate Name</p>
            </option>
          </select>
          </span>
          </label>
          </div>
          
          <span class=" mx-1 d-flex search-by-input ml-5" >
            <select
            v-if="selectOptionToFilter=='programStatus'"
            class="search-group search-by-input__select my-1"
            placeholder=" "
            name="search-group-filter"
            id="search-group-filter"
            v-model="filter"
          >
          <option value="">Show All</option>
            <option v-for="status in programStatusList()" :key='status' :value="status">
              <p>{{status}}</p>
            </option>
          </select>
          <input
           v-else
           class="search-by-input__input"
            type="text"
            name="searchByKey"
            id="searchByKey"
            v-model="filter"
            placeholder="Search here"
            style="width:250px"
          />
          <button class="reset-button" @click="ResetSort">
              <img
                src="@/assets/imgs/spinner.svg"
                alt="Reset button"
                title="Reset"
              />
            </button>
          </span>
          
          <div>
            
          </div>
        </div>
        </div>
    <div class="table-view__table  pt-2 mt-3" :style="setTableHeight" >
      <table class="table">
        <thead>
          <tr class="row justify-content-around m-0 mr-1">
            <th @click="sortColumn('businessName')" class="tabel-header col-2">
              <span class="tabel-header__data" :class="values.currentSort=='businessName'?'show-icon':''">
                <p class="tabel-header__title">Business Name</p>
                <span class="tabel-header__icons functional-icons mx-2">
                  <p class="functional-icons__sorting sort-icon">
                    <strong
                      v-if="values.currentSortDir == 'asc'"
                      class=" sort-icon__up"
                      >&#8593;</strong
                    >
                    <strong
                      v-if="values.currentSortDir == 'desc'"
                      class=" sort-icon__down"
                      >&#8595;</strong
                    >
                  </p>
                </span>
              </span>
          </th>
          <th @click="sortColumn('programName')" class="tabel-header col-2">
              <span class="tabel-header__data" :class="values.currentSort=='programName'?'show-icon':''">
                <p class="tabel-header__title">Program Name</p>
                <span class="tabel-header__icons functional-icons mx-2">
                  <p class="functional-icons__sorting sort-icon">
                    <strong
                      v-if="values.currentSortDir == 'asc'"
                      class=" sort-icon__up"
                      >&#8593;</strong
                    >
                    <strong
                      v-if="values.currentSortDir == 'desc'"
                      class=" sort-icon__down"
                      >&#8595;</strong
                    >
                  </p>
                </span>
              </span>
          </th>
          <th @click="sortColumn('fundingEntityName')" class="tabel-header col-2">
              <span class="tabel-header__data" :class="values.currentSort=='fundingEntityName'?'show-icon':''">
                <p class="tabel-header__title">Funding Entity</p>
                <span class="tabel-header__icons functional-icons mx-2">
                  <p class="functional-icons__sorting sort-icon">
                    <strong
                      v-if="values.currentSortDir == 'asc'"
                      class=" sort-icon__up"
                      >&#8593;</strong
                    >
                    <strong
                      v-if="values.currentSortDir == 'desc'"
                      class=" sort-icon__down"
                      >&#8595;</strong
                    >
                  </p>
                </span>
              </span>
          </th>
          <th @click="sortColumn('programStatus')" class="tabel-header col-2">
              <span class="tabel-header__data" :class="values.currentSort=='programStatus'?'show-icon':''">
                <p class="tabel-header__title">Status</p>
                <span class="tabel-header__icons functional-icons mx-2">
                  <p class="functional-icons__sorting sort-icon">
                    <strong
                      v-if="values.currentSortDir == 'asc'"
                      class=" sort-icon__up"
                      >&#8593;</strong
                    >
                    <strong
                      v-if="values.currentSortDir == 'desc'"
                      class=" sort-icon__down"
                      >&#8595;</strong
                    >
                  </p>
                </span>
              </span>
          </th>
           <th @click="sortColumn('affiliateName')" class="tabel-header col-2">
              <span class="tabel-header__data" :class="values.currentSort=='affiliateName'?'show-icon':''">
                <p class="tabel-header__title">Affiliate Name</p>
                <span class="tabel-header__icons functional-icons mx-2">
                  <p class="functional-icons__sorting sort-icon">
                    <strong
                      v-if="values.currentSortDir == 'asc'"
                      class=" sort-icon__up"
                      >&#8593;</strong
                    >
                    <strong
                      v-if="values.currentSortDir == 'desc'"
                      class=" sort-icon__down"
                      >&#8595;</strong
                    >
                  </p>
                </span>
              </span>
          </th>
           <th @click="sortColumn('dateInvited')" class="tabel-header col-2">
              <span class="tabel-header__data" :class="values.currentSort=='dateInvited'?'show-icon':''">
                <p class="tabel-header__title">Invited Date</p>
                <span class="tabel-header__icons functional-icons mx-2">
                  <p class="functional-icons__sorting sort-icon">
                    <strong
                      v-if="values.currentSortDir == 'asc'"
                      class=" sort-icon__up"
                      >&#8593;</strong
                    >
                    <strong
                      v-if="values.currentSortDir == 'desc'"
                      class=" sort-icon__down"
                      >&#8595;</strong
                    >
                  </p>
                </span>
              </span>
          </th>
          </tr>
        </thead>
        <tbody class="tbody" :style="setTableBodyHeight" >
          <tr v-for="(item) in displayedPosts" :key="item" 
          class="row justify-content-around m-0"
          @click="selectId(item)">
              <td class="tabel-header col-2" >
              <p>{{ item['businessName'] }}</p> 
            </td>
            <td class="tabel-header col-2" >
              <p>{{ item['programName'] }}</p> 
            </td>
            <td class="tabel-header col-2" >
              <p>
                {{item['fundingEntityName']}}
              </p>
            </td>
            <td class="tabel-header col-2" >
              <p>{{ item['programStatus'] }}</p> 
            </td>
             <td class="tabel-header col-2" >
              <p>{{ item['affiliateName'] }}</p> 
            </td>
             <td class="tabel-header col-2" >
              <p>{{ item['dateInvited'] }}</p> 
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class ="table-view__footer" >
      <div class="pagination">
        <div class="pagination__container">
          <div class="pagination__container__total-pages">
            <p>
              {{ filteredRows.length }}
              {{ filteredRows.length > 1 ? labels.Results : labels.Result }}
            </p>
          </div>
          <div class="pagination__container__row-per-page">
            <span>
              <label>
                {{ labels.Rowsperpage }}
              </label>
              <input
                type="Number"
                :max=perPage
                min="1"
                readonly
                :value=perPage
              />
            </span>
          </div>
          <div class="pagination__container__brief">
            <span>
              <p>{{ values.currentPage }}</p>
              <p>{{ labels.of }}</p>
              <p>{{ values.totalPages }}</p>
              <p>{{ labels.pages }}</p>
            </span>
          </div>
          <div class="pagination__container__inc-dec">
            <button @click="backPage()">
              &#60;
            </button>
            <p>{{ values.currentPage }}</p>
            <button @click="nextPage()">
              &#62;
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Pagination from "@/components/Pagination.vue"
export default {
  components: {
    // Pagination
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    perPage: {
      type:Number,
      default:10
      },
      TableHeight:{
        type:Number,
      },
      TableBodyHeight:{
        type:Number,
      },
      columns: {
      required: true,
      type: Array,
    }
  },
  data() {
    return {
      filter: "",
      list: this.items,
      unsort:false,
      selectOptionToFilter: "all",
      labels: {
        ShowingResults: "Showing Results",
        ShowFilters: "Show Filters",
        Results: "Results",
        Result: "Result",
        Rowsperpage: "Rows per page:",
        pages: "Pages",
        of: "of",
      },
      values: {
         pages: [],
        totalPages: 1,
        currentPage: 1,
        currentSort: "",
        currentSortDir: "asc",
        isSearchByAll: true,
      },
    };
  },
   beforeUpdate() {
    this.list = this.items;
  },
  methods: {
    clearFilter(){
      this.filter='';
    },
    ResetSort() {
      this.filter='';
      this.values.currentSort=''
      this.selectOptionToFilter='all';
      this.unsort=true;
    },
    programStatusList(){
        if(this.list.length>0){
           let programStatus =[...new Set(this.list.map(item => item.programStatus))]
            return programStatus.sort() 
        }
        
    },
    highlightMatches(text) {
      const textStr = text.toString();
      const matchExists = textStr.toLowerCase().includes(this.filter);
      if (!matchExists) return textStr;

      const re = new RegExp(this.filter, "ig");
      return textStr.replace(
        re,
        (matchedText) => `<strong>${matchedText}</strong>`
      );
    },
    sortColumn(s) {
      this.unsort = false;
      if (s === this.values.currentSort) {
        this.values.currentSortDir =
          this.values.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.values.currentSort = s;
    },
    selectId(item){
      if (item.businessID > 0) {
          this.$store.state.business.programInvitationActiveTab='programInvitation'
            this.$router.push("/programinvitation/form/"+item.businessID+"/"+0);
      }
    },
    setPages () {
			let numberOfPages = Math.ceil(this.items.length / this.perPage);
			for (let index = 1; index <= numberOfPages; index++) {
				this.values.pages.push(index);
			}
		},
    paginate (posts) {
      if(!posts)
        return [];
			let page = this.values.currentPage;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
      this.values.totalPages =Math.ceil(this.filteredRows.length / this.perPage);
      if(this.values.totalPages===0){
        this.values.totalPages=1
      }
			return  posts.slice(from, to);
		},
    backPage() {
      if (this.values.currentPage > 1) {
        this.values.currentPage--;
      }
    },
    nextPage() {
      if (this.values.currentPage < this.values.totalPages) {
        this.values.currentPage++;
      }
    },
  },
  computed: {
    setTableHeight(){
      return 'height: ' + this.TableHeight +'vh';  
    },
    setTableBodyHeight(){
      return 'height: ' + this.TableBodyHeight +'vh';  
    },
    displayedPosts () {
			return this.paginate(this.filteredRows);
		},
    sortTable() {
      let lists = this.list;
      let data;
      if(this.unsort===true){
        return lists
      }
      data = lists.slice().sort((a, b) => {
        let modifier = 1;
        if (this.values.currentSortDir === "desc") modifier = -1;
        if (a[this.values.currentSort] < b[this.values.currentSort])
          return -1 * modifier;
        if (a[this.values.currentSort] > b[this.values.currentSort])
          return 1 * modifier;
        return 0;
      });

      return data;
    },
    filteredRows() {
      return this.sortTable.filter((row) => {
        const businessName = row.businessName.toLowerCase();
        const programName = row.programName.toLowerCase();
        const fundingEntityName = row.fundingEntityName.toLowerCase();
        const programStatus = row.programStatus.toLowerCase();
        const affiliateName=row.affiliateName.toLowerCase();
        const dateInvited= row.dateInvited.toLowerCase();
        const searchTerm = this.filter.toLowerCase();
        let filtedItems;
        if (this.selectOptionToFilter == "all") {
          filtedItems =
            businessName.includes(searchTerm) ||
            programName.includes(searchTerm) ||
            fundingEntityName.includes(searchTerm) ||
            programStatus.includes(searchTerm)||
            affiliateName.includes(searchTerm)||
            dateInvited.includes(searchTerm);
        }
        if (this.selectOptionToFilter == "businessName") {
          filtedItems = businessName.includes(searchTerm);
        }
        if (this.selectOptionToFilter == "programName") {
          filtedItems = programName.includes(searchTerm);
        }
        if (this.selectOptionToFilter == "fundingEntityName") {
          filtedItems = fundingEntityName.includes(searchTerm);
        }

        if (this.selectOptionToFilter == "affiliateName") {
          filtedItems = affiliateName.includes(searchTerm);
        }
        if (this.selectOptionToFilter == "dateInvited") {
          filtedItems = dateInvited.includes(searchTerm);
        }

        if (this.selectOptionToFilter == "programStatus") {
          if(searchTerm==''){
            filtedItems=true
          }
          else{
          filtedItems = programStatus===searchTerm ;
          }
        }
        // this.items=filtedItems
        return filtedItems;
      });
    },
  },
  watch: {
		posts () {
			this.setPages();
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/_mixins.scss";
  @include table-style;
</style>
